import type { SourcePlatform } from '~entities/import-job/api/types';
import { REQUIRED_CLASS_HEADERS } from '~pages/classes/bulk-upload/types';

import { resolvePreMappedColumn } from './resolve-pre-mapped-column';

function headerSet(headers: Array<string>): Set<string> {
  return new Set(
    headers.map((h) => h.replace(/^\uFEFF/i, '').trim().toLowerCase()).filter(Boolean),
  );
}

/**
 * Required Enrollio class fields that cannot be mapped from the uploaded CSV
 * (no matching header / alias). End Time is treated as satisfiable when
 * Start Time (or Time) + Length/Duration are present for transform.
 */
export function findUnmappableRequiredClassFields(
  sourceHeaders: Array<string>,
  aliases: Record<string, string>,
  sourcePlatform: SourcePlatform,
): Array<string> {
  const lower = headerSet(sourceHeaders);
  const hasStart =
    lower.has('start time') ||
    lower.has('start time x') ||
    lower.has('time');
  const hasDuration =
    lower.has('length') || lower.has('length x') || lower.has('duration');
  const canComputeEndTime = hasStart && hasDuration;

  const missing: Array<string> = [];
  for (const field of REQUIRED_CLASS_HEADERS) {
    if (field === 'End Time' && canComputeEndTime) {
      continue;
    }
    const mapped = resolvePreMappedColumn(
      field,
      sourceHeaders,
      aliases,
      sourcePlatform,
    );
    if (!mapped) {
      missing.push(field);
    }
  }
  return missing;
}
